import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Typography, Dropdown, Button, notification, Menu } from 'antd';
import { CustomImage, CustomPageHeader, CustomTable, useText } from '@src/components';
import { formatPlate, getFileNameByLanguage } from '@src/utils/utils';
import filterButton from '@src/assets/icons/icon-task-square.svg';
import '@src/styles/demands/demands.scss';
import dayjs from '@src/utils/day';
import CustomFilterCollapse from '@src/components/CustomFilterCollapse';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import CustomLoadingSpin from '@src/components/CustomLoadingSpin';
import { getVehicleFuelTransaction } from '@src/store/slice/fuelConsumptionStore/fuelConsumptionSlice';
import {
  getVehicleDepartments,
  getVehicleCostCenter,
  getVehicleLAddressGetList,
} from '@src/store/slice/addNewCarStore/addCarPlateDetailSlice';
import download from 'js-file-download';
import iconDown from '@src/assets/icons/setting_4.svg';
import iconPDF from '@src/assets/icons/icn_filtrele.svg';
import fuelConsumption from '@src/services/fuelConsumption/fuelConsumption.services';
import { getVehicleActivityLogs } from '@src/store/slice/demandsStore/demandsSlice';

const { Text } = Typography;

const FuelConsumption = (props) => {
  const deliveryAddress2Text = useText('deliveryAddress2');
  const fuelConsumptionReport = useText('fuelConsumptionReport');
  const licensePlate2 = useText('licensePlate2');
  const station = useText('station');
  const transactionDate2 = useText('transactionDate2');
  const unitPrice = useText('unitPrice');
  const quantity = useText('quantity');
  const amount2 = useText('amount2');
  const fuelType = useText('fuelType');
  const deviceType4 = useText('deviceType4');
  const licensePlate3 = useText('licensePlate3');
  const dateRange = useText('dateRange');
  const deviceType5 = useText('deviceType5');
  const department = useText('department');
  const costCenter = useText('costCenter');
  const filter2 = useText('filter2');
  const downloadReportPdf = useText('downloadReportPdf');
  const downloadReportXls = useText('downloadReportXls');
  const smartRing = useText('smartRing');
  const fuelCard = useText('fuelCard');
  const totalRingSystem = useText('totalRingSystem');
  const bpKeychain = useText('bpKeychain');
  const mobileApp = useText('mobileApp');
  
  const dispatch = useDispatch();
  const { fuelConsumptions, loading, pagedProperty } = useSelector(
    (state) => state.fuelConsumption,
  );
  const {
    vehicleDepartments = [],
    vehicleCostCenters = [],
    vehicleLAddressGetList = [],
  } = useSelector((state) => state.addCarPlateDetail);

  const {
    deviceTypeList = {
      2: smartRing,
      3: fuelCard,
      10: totalRingSystem,
      13: bpKeychain,
      17: mobileApp,
    },
  } = useSelector((state) => state.demands);
  const [devices, setDevices] = useState(null);
  const [plateList, setPlateList] = useState([]);
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const [filteredText, setFilteredText] = useState('');
  const [filteredPlateQuery, setFilteredPlateQuery] = useState('');
  const [filteredDate, setFilteredDate] = useState('');
  const [panels, setPanels] = useState([]);
  const [filterDepartments, setFilterDepartments] = useState([]);
  const [filterCosts, setFilterCosts] = useState([]);
  const [filteredPlate, setFilteredPlate] = useState('');
  const [filteredAdd, setFilteredAdd] = useState('');
  const [checkedOperations, setCheckedOperations] = useState([]);
  const [checkedDepartments, setCheckedDepartments] = useState([]);
  const [checkedCostCenters, setCheckedCostCenters] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [disableTicketCarPage, setDisableTicketCarPage] = useState(true);
  const [isBeforeRequest, setIsBeforeRequest] = useState(true);
  const { menus } = useSelector((state) => state.menus);
  const inputRef = useRef(null);
  const [api, contextHolder] = notification.useNotification();
  const history = useHistory();
  const [columns, setColumns] = useState([]);
  const [fuels, setFuels] = useState([]);
  const [requestFilter, setRequestFilter] = useState(null);
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const { selectedCustomer } = useSelector((state) => state.customer);


  const serviceIdCol = {
    title: fuelType,
    dataIndex: 'serviceId',
    key: 'serviceId',
    align: 'left',
    width: 80,
    height: 50,
    render: (text) => text,
  };

  const deviceTypeLabelCol = {
    title: deviceType4,
    dataIndex: 'deviceTypeLabel',
    key: 'deviceTypeLabel',
    align: 'left',
    width: 70,
    height: 50,
    render: (text) => text,
  };

  const plateCol = {
    title: licensePlate2,
    dataIndex: 'plateNumber',
    key: 'plateNumber',
    align: 'left',
    width: 78,
    height: 50,
    className: 'custom-plate-column',
    render: (text) => formatPlate(text),
  };

  /*useEffect(() => {
    if (menus && !isAdmin) {
      if (menus.filter((item) => item.text?.includes('TICKET CAR')).length < 1) {
        setDisableTicketCarPage(false);
      }
    }
  }, [menus]);*/

  function formatCurrency(value) {
    const formattedValue = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
    }).format(value);
    return formattedValue.replace('₺', '') + ' ₺';
  }

  useEffect(() => {
    let tempColumns = [
      {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
        align: 'center',
        width: 30,
        height: 50,
        className: 'custom-id-column',
      },
    ];
    if (isMobil) {
      tempColumns = tempColumns.concat([plateCol, deviceTypeLabelCol, serviceIdCol]);
    } else {
      tempColumns = tempColumns.concat([
        plateCol,
        deviceTypeLabelCol,
        serviceIdCol,
        {
          title: station,
          dataIndex: 'stationName',
          key: 'stationName',
          align: 'left',
          width: 120,
          height: 50,
        },
        {
          title: transactionDate2,
          dataIndex: 'salesDate',
          key: 'salesDate',
          align: 'left',
          width: 90,
          height: 50,
          render: (salesDate) =>
            salesDate && dayjs(salesDate).isValid()
              ? dayjs(salesDate).format('DD/MM/YYYY HH:mm')
              : '-',
        },
        {
          title: unitPrice,
          dataIndex: 'unitPrice',
          key: 'unitPrice',
          align: 'left',
          width: 90,
          height: 50,
          render: (text) => formatCurrency(text),
        },
        {
          title: quantity,
          dataIndex: 'volume',
          key: 'volume',
          align: 'left',
          width: 90,
          height: 50,
          render: (text) => text + ' LT',
        },
        {
          title: amount2,
          dataIndex: 'amount',
          key: 'amount',
          align: 'left',
          width: 90,
          height: 50,
          render: (text) => formatCurrency(text),
        },
      ]);
    }
    setColumns(tempColumns);
  }, [isMobil]);

  useEffect(() => {
    if (fuelConsumptions) {
      const arr = fuelConsumptions.map((item) => {
        let temp = { ...item };
        const one = temp.salesDate?.split('/')[0];
        const two = temp.salesDate?.split('/')[1];
        temp.salesDate = temp.salesDate.replace(one + '/' + two, two + '/' + one);
        return temp;
      });
      setFuels(arr);
    }
  }, [fuelConsumptions]);

  useEffect(() => {
    if (!disableTicketCarPage && history) {
      history.push('/dashboard');
    }
  }, [disableTicketCarPage]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [filteredText]);

  const fetchVehicleListDataBefore = async (flag = true) => {
    fetchAddressAndPlates();
    await fetchVehicleListData2();
    let req = { PageNumber: 1, PageSize: 100000 };
    if (isAdmin && selectedUserId) {
      req.customerId = parseInt(selectedUserId, 10);
    }
    const action = await dispatch(getVehicleFuelTransaction(req));
    console.log('getVehicleFuelTransaction action', action);
    if (getVehicleFuelTransaction.fulfilled.match(action) && action?.payload?.data) {
      let plates = [];
      let actionDevices = [];
      action?.payload?.data?.map((item, index) => {
        if (plates?.filter((plate) => plate?.name === item.plateNumber).length < 1) {
          plates.push({
            id: index + 1,
            name: item.plateNumber,
          });
        }
        if (actionDevices?.filter((device) => device?.value === item.deviceTypeLabel).length < 1) {
          Object.entries(deviceTypeList).map(([key, value]) => {
            if (item.deviceTypeLabel === value) {
              actionDevices.push({
                key: key,
                value: value,
              });
            }
          });
        }
      });
      setPlateList(plates);
      setDevices(actionDevices);
    }
    setIsBeforeRequest(false);
  };

  const fetchVehicleListData = async (flag = true) => {
    let req = { PageNumber: !flag ? 1 : pagination.current, PageSize: pagination.pageSize };
    if (isAdmin && selectedUserId) {
      req.customerId = parseInt(selectedUserId, 10);
    }
    if (flag) {
      req = getFilterRequestForDownload(req);
    }
    await dispatch(getVehicleFuelTransaction(req));
  };

  const fetchVehicleListData2 = async () => {
    let req = { pageNumber: pagination.current, pageSize: pagination.pageSize };
    if (isAdmin && selectedUserId) {
      req.customerId = parseInt(selectedUserId, 10);
    }
    await dispatch(getVehicleActivityLogs(req));
  };

  const fetchAddressAndPlates = () => {
    if (isAdmin && selectedUserId) {
      dispatch(getVehicleLAddressGetList({ customerId: selectedUserId }));
      dispatch(getVehicleDepartments({ customerId: selectedUserId, vouId: 4 }));
      dispatch(getVehicleCostCenter({ customerId: selectedUserId, vouId: 4 }));
    } else {
      dispatch(getVehicleLAddressGetList());
      dispatch(getVehicleDepartments({ vouId: 4 }));
      dispatch(getVehicleCostCenter({ vouId: 4 }));
    }
  };

  useEffect(() => {
    if (isBeforeRequest) {
      fetchVehicleListDataBefore();
    } else {
      fetchVehicleListData();
    }
  }, [dispatch, pagination, selectedUserId]);

  const getFilterRequestForDownload = (request) => {
    if (requestFilter) {
      request.addressId = requestFilter?.addressId ?? null;
      request.plateNumber = requestFilter?.plateNumber ?? null;
      request.startDate = requestFilter?.startDate ?? null;
      request.endDate = requestFilter?.endDate ?? null;
      request.vehicleDepartmentId = requestFilter?.vehicleDepartmentId ?? null;
      request.costCenterId = requestFilter?.costCenterId ?? null;
      request.deviceTypeId = requestFilter?.deviceTypeId ?? null;
    }
    return request;
  };

  const downloadExcel = async () => {
    try {
      let request = {
        VouId: 4,
        CustomerId:
          isAdmin && selectedUserId ? parseInt(selectedUserId, 10) : selectedCustomer.customerId,
      };
      request = getFilterRequestForDownload(request);

      const data = await fuelConsumption.downloadVehicleFuelTransactionsFile(request);

      download(data, `${getFileNameByLanguage('YakitTuketimRaporu', 'FuelConsumptionReport')}.xlsx`);
    } catch (error) {
      console.error('downloadExcel', error);
    }
  };

  const downloadPDF = async () => {
    try {
      let request = {
        VouId: 4,
        CustomerId:
          isAdmin && selectedUserId ? parseInt(selectedUserId, 10) : selectedCustomer.customerId,
      };
      request = getFilterRequestForDownload(request);
      const data = await fuelConsumption.downloadVehicleFuelTransactionsPDFFile(request);
      download(data, `${getFileNameByLanguage('YakitTuketimRaporu', 'FuelConsumptionReport')}.pdf`);
    } catch (error) {
      console.error('downloadPDF', error);
    }
  };

  useEffect(() => {
    if (!isBeforeRequest) fetchAddressAndPlates();
  }, [dispatch, selectedUserId]);

  useEffect(() => {
    setPanels([
      {
        setList: setFilteredDate,
        text: dateRange,
        key: 'salesDate',
        date: true,
        defaultValue: filteredDate,
      },
      {
        setList: setFilteredPlate,
        text: licensePlate3,
        initialList: plateList,
        key: 'plateNumber',
        input: true,
        defaultValue: filteredPlate,
      },
      /*{
        list: checkedOperations,
        setList: setCheckedOperations,
        text: 'Yakıt Tipi',
        initialList: filterFuels,
        key: 'fuelType',
      },*/
      {
        list: checkedOperations,
        setList: setCheckedOperations,
        text: deviceType5,
        initialList: devices,
        key: 'deviceType',
        checkboxStatus: 1,
      },
      {
        list: checkedDepartments,
        setList: setCheckedDepartments,
        text: department,
        initialList: filterDepartments,
        key: 'departman',
        checkboxStatus: 1,
      },
      {
        list: checkedCostCenters,
        setList: setCheckedCostCenters,
        text: costCenter,
        initialList: filterCosts,
        key: 'costCenter',
        checkboxStatus: 1,
      },
      {
        setList: setFilteredAdd,
        text: deliveryAddress2Text,
        initialList: vehicleLAddressGetList,
        input: true,
        key: 'owner',
        defaultValue: filteredAdd,
      },
    ]);
  }, [
    vehicleLAddressGetList,
    filterCosts,
    filterDepartments,
    plateList,
    devices,
    checkedCostCenters,
    checkedDepartments,
    checkedOperations,
    filteredAdd,
    filteredPlate,
    filteredDate,
  ]);

  useEffect(() => {
    if (vehicleDepartments) {
      const arr = vehicleDepartments.map((item) => {
        return { key: item.id, value: item.label };
      });
      setFilterDepartments(arr);
    }
  }, [vehicleDepartments]);

  useEffect(() => {
    if (vehicleCostCenters) {
      const arr = vehicleCostCenters.map((item) => {
        return { key: item.costCenterId, value: item.costCenterLabel };
      });
      setFilterCosts(arr);
    }
  }, [vehicleCostCenters]);

  const clearDemands = () => {
    try {
      setFilteredPlateQuery('');
      setRequestFilter(null);
      setFilteredPlate('');
      setFilteredAdd('');
      setFilteredText('');
      setFilteredDate('');
      setCheckedOperations([]);
      setCheckedCostCenters([]);
      setCheckedDepartments([]);
      fetchVehicleListData(false);
    } catch (error) {
      console.error(error);
    }
  };

  const clickFilter = async (tempFilter = null) => {
    try {
      const filter = {
        addressId: filteredAdd
          ? vehicleLAddressGetList?.filter((item) => item.name === filteredAdd)[0]?.id
          : null,
        plateNumber: filteredPlate,
        startDate: filteredDate?.start,
        endDate: filteredDate?.end,
        costCenterId: checkedCostCenters?.length > 0 ? checkedCostCenters[0] : null,
        vehicleDepartmentId: checkedDepartments?.length > 0 ? checkedDepartments[0] : null,
        deviceTypeId: checkedOperations?.length > 0 ? checkedOperations[0] : null,
      };
      let req = { PageNumber: 1, PageSize: pagination.pageSize };
      if (isAdmin && selectedUserId) {
        req.customerId = parseInt(selectedUserId, 10);
      }

      req.addressId = filter?.addressId ?? null;
      req.plateNumber = filter?.plateNumber ?? null;
      req.startDate = filter?.startDate ?? null;
      req.endDate = filter?.endDate ?? null;
      req.vehicleDepartmentId = filter?.vehicleDepartmentId ?? null;
      req.costCenterId = filter?.costCenterId ?? null;
      req.deviceTypeId = filter?.deviceTypeId ?? null;
      setRequestFilter(req);
      const response = await dispatch(getVehicleFuelTransaction(req));
      setFuels(response?.payload?.data ?? []);
    } catch (error) {
      console.error(error);
    }
  };

  const listenClickCheckbox = (setList, tempList) => {
    setList(tempList);
  };

  function FilterMenu() {
    return (
      <div className="custom-filter-menu">
        <div className="demands-custom-menu-div">
          <span className="custom-filter-menu-filtrele">{filter2}</span>
          <button onClick={clearDemands} className="custom-filter-menu-clear">
            <Text t="clean" /></button>
        </div>

        <CustomFilterCollapse panels={panels} listenClickCheckbox={listenClickCheckbox} />

        <Button
          type="primary"
          onClick={clickFilter}
          block
          className="custom-filter-menu-filter-button"
        >
          <CustomImage src={filterButton} /> {filter2}
        </Button>
      </div>
    );
  }

  const handlePageChange = (page, pageSize) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current: page?.current,
    }));
  };

  const menu = (
    <Menu>
      <Menu.Item onClick={downloadPDF}>{downloadReportPdf}</Menu.Item>
      <Menu.Item onClick={downloadExcel}>{downloadReportXls}</Menu.Item>
    </Menu>
  );

  const content = () => {
    return loading.fuelConsumptions ? (
      <CustomLoadingSpin />
    ) : (
      <Card
        title={fuelConsumptionReport}
        className="balance-list-container"
        headStyle={{ fontFamily: 'UbuntuRegular', fontSize: '18px', fontWeight: 'bolder' }}
        extra={
          <div className="balance-tools" style={{ width: 144 }}>
            <div className="header-notification" style={{ backgroundColor: 'transparent' }} />

            <div className="header-notification">
              <Dropdown overlay={<FilterMenu />} trigger={['click']}>
                <Button
                  type="text"
                  icon={<CustomImage src={iconDown} />}
                  className="demands-filter-image-button"
                />
              </Dropdown>
            </div>
            <div className="header-notification">
              <Dropdown overlay={menu} trigger={['click']}>
                <Button
                  type="text"
                  icon={<CustomImage src={iconPDF} />}
                  className="demands-filter-image-button"
                />
              </Dropdown>
            </div>
          </div>
        }
      >
        {contextHolder}
        <CustomTable
          data-testid="table-test-id"
          pagination={
            pagedProperty?.totalItems < 11
              ? false
              : {
                pageSize: pagination?.pageSize,
                total: pagedProperty?.totalItems,
                current: pagination?.current,
                className: 'demands-list-pagination',
              }
          }
          onPageChange={handlePageChange}
          dataSource={fuels}
          columns={columns}
          className="babs-list-table"
          rowKey={(record) => record.id}
        />
      </Card>
    );
  };

  return (
    <CustomPageHeader
      data-testid="demands-test-id"
      title={isAdmin ? null : fuelConsumptionReport}
      showBreadCrumb={!isAdmin}
      showHelpButton={!isAdmin}
      adminCustomHeaderContent={isAdmin ? 'custom-header-content-subpage' : ''}
      routes={['ticketCarHeader']}
    >
      {content()}
    </CustomPageHeader>
  );
};

export default FuelConsumption;
